import React from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import {
  TailwindToaster,
  GmapsComponent,
  PropertyThumbnail,
} from "../../components";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { FileUploader } from "react-drag-drop-files";
import CryptoJS from "crypto-js";
import Multiselect from "multiselect-react-dropdown";

import axios from "../../api/axios";
import { downloadBlobFile, uploadBlobToContainer } from "../../api/azure";
import { reverseGeoCode } from "../../api/maps";

const PIFCreate = () => {
  const state = useSelector((state) => state.UserReducer);
  const { serviceTicketId } = useParams();
  const createUrl = "/pif/" + serviceTicketId;
  const serviceTicketUrl = "/serviceticket/" + serviceTicketId;
  const navigate = useNavigate();
  const blobContainerName = "propertyimages";
  const propertyLocationUrl = "/pifLocation";

  const [pifLocationsSelectedData, setPifLocationsSelectedData] =
    React.useState([]);

  const [propertyLocationsData, setPropertyLocationsData] = React.useState([]);
  const getPropertyLocations = () => {
    try {
      axios
        .get(propertyLocationUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.pifLocations?.length > 0) {
            setPropertyLocationsData(response.data.pifLocations);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const [propertySubType, setPropertySubType] = React.useState("Building"); // Building / Land
  const [furnishedStatus, setFurnishedStatus] = React.useState("");
  const [requestLoading, setRequestLoading] = React.useState(false);
  const buildingList = [
    "apartment",
    "independent house",
    "farm house",
    "business and hotel",
  ];

  const [roadKuthalEnabled, setRoadKuthalEnabled] = React.useState(false);
  const [vastuComplianceEnabled, setVastuComplianceEnabled] =
    React.useState(false);
  const [loanableEnabled, setLoanableEnabled] = React.useState(false);
  const [physicalMeasurementEnabled, setPhysicalMeasurementEnabled] =
    React.useState(false);
  const [groundWaterEnabled, setGroundWaterEnabled] = React.useState(false);
  const [ebhtEnabled, setebhtEnabled] = React.useState(false);
  const [ebltEnabled, setebltEnabled] = React.useState(false);

  const [templeEnabled, settempleEnabled] = React.useState(false);
  const [waterEnabled, setwaterEnabled] = React.useState(false);
  const [burialGroundEnabled, setburialGroundEnabled] = React.useState(false);
  const [porambokeEnabled, setporambokeEnabled] = React.useState(false);
  const [quarryEnabled, setquarryEnabled] = React.useState(false);
  const [railwayTrackEnabled, setrailwayTrackEnabled] = React.useState(false);
  const [gatedSociety, setgatedSociety] = React.useState(false);
  const [cornerProperty, setcornerProperty] = React.useState(false);
  const [petFriendly, setpetFriendly] = React.useState(false);
  const [wheelchairFriendly, setWheelChairFriendly] = React.useState(false);
  const [studyRoom, setstudyRoom] = React.useState(false);
  const [storeRoom, setstoreRoom] = React.useState(false);
  const [poojaRoom, setpoojaRoom] = React.useState(false);
  const [servantRoom, setservantRoom] = React.useState(false);
  const [outdoorSportsEnabled, setoutdoorSportsEnabled] = React.useState(false);
  const [indoorSportsEnabled, setindoorSportsEnabled] = React.useState(false);
  const [fittingsEnabled, setfittingsEnabled] = React.useState(false);
  const [wallsPaintEnabled, setwallsPaintEnabled] = React.useState(false);
  const [stove, setstove] = React.useState(false);
  const [microwave, setmicrowave] = React.useState(false);
  const [diningTable, setdiningTable] = React.useState(false);
  const [modularkitchen, setmodularkitchen] = React.useState(false);
  const [washingMachine, setwashingMachine] = React.useState(false);
  const [curtains, setcurtains] = React.useState(false);
  const [fridge, setfridge] = React.useState(false);
  const [waterPurifier, setwaterPurifier] = React.useState(false);
  const [waterPurifier2, setwaterPurifier2] = React.useState(false);
  const [chimney, setchimney] = React.useState(false);
  const [sofaenabled, setsofaenabled] = React.useState(false);
  const [exhaustFan, setexhaustFan] = React.useState(false);

  const [visitorParking, setvisitorParking] = React.useState(false);
  const [fireAlarm, setfireAlarm] = React.useState(false);
  const [securityPersonnel, setsecurityPersonnel] = React.useState(false);
  const [maintanenceStaff, setmaintanenceStaff] = React.useState(false);
  const [waterStorage, setwaterStorage] = React.useState(false);
  const [centralAC, setcentralAC] = React.useState(false);
  const [vaasthuCompliant, setvaasthuCompliant] = React.useState(false);
  const [waterDisposal, setwaterDisposal] = React.useState(false);
  const [gym, setgym] = React.useState(false);
  const [rainWaterHarvesting, setrainWaterHarvesting] = React.useState(false);
  const [atmenabled, setatmenabled] = React.useState(false);
  const [barenabled, setbarenabled] = React.useState(false);
  const [swimmingPool, setswimmingPool] = React.useState(false);
  const [lifts, setlifts] = React.useState(false);
  const [clubHouse, setclubHouse] = React.useState(false);
  const [intercomFacility, setintercomFacility] = React.useState(false);
  const [serviceLift, setserviceLift] = React.useState(false);
  const [highSpeedInternet, sethighSpeedInternet] = React.useState(false);
  const [cafeteria, setcafeteria] = React.useState(false);
  const [parkenabled, setparkenabled] = React.useState(false);
  const [conferenceRoom, setconferenceRoom] = React.useState(false);
  const [pipedGas, setpipedGas] = React.useState(false);
  const [privateGarden, setprivateGarden] = React.useState(false);
  const [shoppingCentre, setshoppingCentre] = React.useState(false);
  const [parkingAvailable, setparkingAvailable] = React.useState(false);
  const [websitePublish, setwebsitePublish] = React.useState(false);
  const [pifLocations, setPIFLocations] = React.useState([]);

  const [validLongitude, setLongitudeValidity] = React.useState(true);
  const [validLatitude, setLatitudeValidity] = React.useState(true);
  const [validAddress1, setAddress1Validity] = React.useState(true);
  const [validAddress2, setAddress2Validity] = React.useState(true);
  const [validCity, setCityValidity] = React.useState(true);
  const [validState, setStateValidity] = React.useState(true);
  const [validCountry, setCountryValidity] = React.useState(true);
  const [validPincode, setPincodeValidity] = React.useState(true);
  const [validLandmark, setLandmarkValidity] = React.useState(true);
  const [validPrice, setPriceValidity] = React.useState(true);
  const [enquiryData, setEnquiryData] = React.useState({});

  const getServiceTicketDetails = () => {
    try {
      axios
        .get(serviceTicketUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.serviceTicket) {
            setPropertySubType(
              response.data.serviceTicket.subPropertyOptionId.name,
            );
            if (
              (response.data.serviceTicket?.serviceTypeId?.name
                ?.toLowerCase()
                .includes("brokerage") &&
                response.data.serviceTicket?.subServiceTypeId?.name
                  ?.toLowerCase()
                  .includes("sell")) ||
              (response.data.serviceTicket?.serviceTypeId?.name
                ?.toLowerCase()
                .includes("rental") &&
                response.data.serviceTicket?.subServiceTypeId?.name
                  ?.toLowerCase()
                  .includes("landlord"))
            )
              setEnquiryData(response.data.enquiryData);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const [facing, setFacing] = React.useState("");
  const [buildingFloors, setBuildingFloors] = React.useState("");

  React.useEffect(() => {
    getPropertyLocations();
    if (enquiryData.pifLat) {
      setTimeout(() => {
        setMarkerCoordinates({
          lat: enquiryData.pifLat,
          lng: enquiryData.pifLng,
        });
        setparkingAvailable(enquiryData.pifParkingAvailable);
        setPropertyImageAttachments(enquiryData.pifPropertyImages);
        document.getElementById("frontage").value = enquiryData.pifFrontage;
        setFacing(enquiryData.pifFacing);
        setBuildingFloors(enquiryData.pifBuildingFloors);
        document.getElementById("facing").value = enquiryData.pifFacing
          ? enquiryData.pifFacing
          : "";
        document.getElementById("buildingFloors").value =
          enquiryData.pifBuildingFloors;
      }, 800);
    }
  }, [enquiryData]);

  const handleSubmit = (event) => {
    var canSubmit = true;
    const pifData = new FormData(event.target);

    setLongitudeValidity(true);
    setLatitudeValidity(true);
    setAddress1Validity(true);
    setAddress2Validity(true);
    setCityValidity(true);
    setStateValidity(true);
    setCountryValidity(true);
    setPincodeValidity(true);
    setLandmarkValidity(true);
    setPriceValidity(true);

    if (pifData.get("longitude") === "") {
      setLongitudeValidity(false);
      canSubmit = false;
    }

    if (pifData.get("latitude") === "") {
      setLatitudeValidity(false);
      canSubmit = false;
    }

    if (pifData.get("addressline1") === "") {
      setAddress1Validity(false);
      canSubmit = false;
    }

    if (pifData.get("addressline2") === "") {
      setAddress2Validity(false);
      canSubmit = false;
    }

    if (pifData.get("city") === "") {
      setCityValidity(false);
      canSubmit = false;
    }

    if (pifData.get("state") === "") {
      setStateValidity(false);
      canSubmit = false;
    }

    if (pifData.get("country") === "") {
      setCountryValidity(false);
      canSubmit = false;
    }

    if (pifData.get("pin_code") === "") {
      setPincodeValidity(false);
      canSubmit = false;
    }

    if (pifData.get("landmark") === "") {
      setLandmarkValidity(false);
      canSubmit = false;
    }

    if (pifData.get("price") === "") {
      setPriceValidity(false);
      canSubmit = false;
    }

    if (!canSubmit) {
      return;
    }
    setRequestLoading(true);
    const dataToSubmit = {
      neightbouringArea: pifData.get("neightbouringArea"),
      longitude: pifData.get("longitude"),
      latitude: pifData.get("latitude"),
      landmark: pifData.get("landmark"),
      price: pifData.get("price"),
      addressline1: pifData.get("addressline1"),
      addressline2: pifData.get("addressline2"),
      city: pifData.get("city"),
      state: pifData.get("state"),
      country: pifData.get("country"),
      pin_code: pifData.get("pin_code"),
      locationType: pifData.get("locationType"),
      shape: pifData.get("shape"),
      approachRoadSize: pifData.get("approachRoadSize"),
      roadType: pifData.get("roadType"),
      frontage: pifData.get("frontage"),
      surroundingDetails: pifData.get("surroundingDetails"),
      propertyNumber: pifData.get("propertyNumber"),
      propertyNumberType: pifData.get("propertyNumberType"),
      guideLineValue: pifData.get("guideLineValue"),
      approvalAuthority: pifData.get("approvalAuthority"),
      approvalType: pifData.get("approvalType"),
      villageName: pifData.get("villageName"),
      sroName: pifData.get("sroName"),
      approvalNumber: pifData.get("approvalNumber"),
      talukName: pifData.get("talukName"),
      accusationPossibility: pifData.get("accusationPossibility"),
      accusationPossibilityOther: pifData.get("accusationPossibilityOther"),
      loanableEnabled,
      websitePublish,
      constructedArea: pifData.get("constructedArea"),
      carpetArea: pifData.get("carpetArea"),
      areaUnitValue: pifData.get("areaUnitValue"),
      areaUnit: pifData.get("areaUnit"),
      vastuComplianceEnabled,
      facing: pifData.get("facing"),
      buildingFloors: pifData.get("buildingFloors"),
      buildingAge: pifData.get("buildingAge"),
      landSizeValue: pifData.get("landSizeValue"),
      landExistingUse: pifData.get("landExistingUse"),
      dimensions: pifData.get("dimensions"),
      physicalMeasurementEnabled,
      solidType: pifData.get("solidType"),
      groundWaterEnabled,
      groundWaterType: pifData.get("groundWaterType"),
      groundWaterLevel: pifData.get("groundWaterLevel"),
      floorAllowedToConstruct: pifData.get("floorAllowedToConstruct"),
      undividedShareValue: pifData.get("undividedShareValue"),
      ebhtEnabled,
      ebhtDistance: pifData.get("ebhtDistance"),
      ebltEnabled,
      ebltDistance: pifData.get("ebltDistance"),
      templeEnabled,
      templeDistance: pifData.get("templeDistance"),
      waterEnabled,
      waterDistance: pifData.get("waterDistance"),
      burialGroundEnabled,
      burialGroundDistance: pifData.get("burialGroundDistance"),
      railwayTrackEnabled,
      railwayTrackDistance: pifData.get("railwayTrackDistance"),
      porambokeEnabled,
      quarryEnabled,
      quarryDistance: pifData.get("quarryDistance"),
      advantages: pifData.get("advantages"),
      opinion: pifData.get("opinion"),
      remarks: pifData.get("remarks"),
      bedroomWithBalcony: pifData.get("bedroomWithBalcony"),
      hallWithBalcony: pifData.get("hallWithBalcony"),
      bedroomWithoutBalcony: pifData.get("bedroomWithoutBalcony"),
      kitchen: pifData.get("kitchen"),
      hallWithoutBalcony: pifData.get("hallWithoutBalcony"),
      gatedSociety,
      cornerProperty,
      petFriendly,
      wheelchairFriendly,
      studyRoom,
      storeRoom,
      poojaRoom,
      servantRoom,
      boundaryWall: pifData.get("boundaryWall"),
      bathrooms: pifData.get("bathrooms"),
      balconies: pifData.get("balconies"),
      outdoorSportsEnabled,
      outdoorSports: pifData.get("outdoorSports"),
      indoorSportsEnabled,
      indoorSports: pifData.get("indoorSports"),
      fittingsEnabled,
      fittingsComment: pifData.get("fittingsComment"),
      wallsPaintEnabled,
      flooring: pifData.get("flooring"),
      noofrooms: pifData.get("noofrooms"),
      qualityRatings: pifData.get("qualityRatings"),
      furnishing: pifData.get("furnishing"),
      wardrobe: pifData.get("wardrobe"),
      beds: pifData.get("beds"),
      geyser: pifData.get("geyser"),
      fans: pifData.get("fans"),
      light: pifData.get("light"),
      aircondition: pifData.get("aircondition"),
      television: pifData.get("television"),
      stove,
      microwave,
      diningTable,
      modularkitchen,
      washingMachine,
      curtains,
      fridge,
      waterPurifier,
      waterPurifier2,
      chimney,
      sofaenabled,
      exhaustFan,
      otherFurnishing: pifData.get("otherFurnishing"),
      visitorParking,
      fireAlarm,
      securityPersonnel,
      maintanenceStaff,
      waterStorage,
      centralAC,
      vaasthuCompliant,
      waterDisposal,
      gym,
      rainWaterHarvesting,
      swimmingPool,
      lifts,
      clubHouse,
      intercomFacility,
      serviceLift,
      atmenabled,
      highSpeedInternet,
      cafeteria,
      parkenabled,
      barenabled,
      conferenceRoom,
      pipedGas,
      privateGarden,
      shoppingCentre,
      parkingAvailable,
      openParkingCnt: pifData.get("openParkingCnt"),
      closedParkingCnt: pifData.get("closedParkingCnt"),
      powerBackup: pifData.get("powerBackup"),
      waterSource: pifData.get("waterSource"),
      overLooking: pifData.get("overLooking"),
      thumbnail: thumbnailObject,
      propertyImageAttachments,
      pifLocations,
    };

    try {
      axios
        .post(createUrl, JSON.stringify(dataToSubmit), {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response.data.message);
            setTimeout(() => {
              window.scrollTo(0, 0);
              navigate(-1);
            }, 0);
          } else {
            toast.error(response.data.message);
          }
        })
        .catch((err) => {
          toast.error(err.message);
        });
    } catch (err) {
      console.log(err);
      toast.error(err.message);
    } finally {
      setRequestLoading(false);
    }
  };

  const [markerCoordinates, setMarkerCoordinates] = React.useState({
    lat: 0,
    lng: 0,
  });
  const updatedMarkerPosition = (coordinates) => {
    setMarkerCoordinates(coordinates);
  };

  const decodeAddress = async (latitude, longitude) => {
    const decodedResponse = await reverseGeoCode(latitude, longitude);
    document.getElementById("pin_code").value = decodedResponse.data.address
      .postcode
      ? decodedResponse.data.address.postcode
      : "";
    document.getElementById("country").value = decodedResponse.data.address
      .country
      ? decodedResponse.data.address.country
      : "";
    document.getElementById("state").value = decodedResponse.data.address.state
      ? decodedResponse.data.address.state
      : "";
    document.getElementById("city").value = decodedResponse.data.address.city
      ? decodedResponse.data.address.city
      : decodedResponse.data.address.county
      ? decodedResponse.data.address.county
      : decodedResponse.data.address.village
      ? decodedResponse.data.address.village
      : "";
    const displayName = decodedResponse.data.display_name.split(", ");
    const median = Number.parseInt(displayName.length / 2);
    const landmark = [];
    if (decodedResponse.data.address.neighbourhood)
      landmark.push(decodedResponse.data.address.neighbourhood);
    if (decodedResponse.data.address.suburb)
      landmark.push(decodedResponse.data.address.suburb);
    if (decodedResponse.data.address.city_district)
      landmark.push(decodedResponse.data.address.city_district);
    if (decodedResponse.data.address.municipality)
      landmark.push(decodedResponse.data.address.municipality);
    document.getElementById("landmark").value = landmark.join(", ");

    // if (decodedResponse?.status !== 500) {
    //   // console.log(decodedResponse?.data);
    // }
  };

  React.useEffect(() => {
    document.getElementById("longitude").value = markerCoordinates.lng;
    document.getElementById("latitude").value = markerCoordinates.lat;
    // console.log("Changed");
    decodeAddress(
      markerCoordinates.lat.toString(),
      markerCoordinates.lng.toString(),
    );
  }, [markerCoordinates]);

  const [thumbnailObject, setThumbnail] = React.useState({});
  const [thumbnailImage, setThumbnailImage] = React.useState("");

  const [propertyImageAttachments, setPropertyImageAttachments] =
    React.useState([]);
  const uploadPropertyImage = async (files) => {
    toast.success("Uploading images to Storage");
    let propertyImages = [];
    for (let i = 0; i < files.length; i++) {
      const fileExtension = files[i].name.split(".")[1];
      const blobName =
        CryptoJS.AES.encrypt(
          files[i].name + Date.now().toString(),
          process.env.REACT_APP_CIPHER_CODE,
        )
          .toString()
          .replace(/[^a-zA-Z0-9_]/g, "") + ".crypt";
      // + fileExtension;
      try {
        const uploadBlobResult = await uploadBlobToContainer(
          blobContainerName,
          blobName,
          files[i],
        );
        if (uploadBlobResult.status === "success") {
          const blobItem = {
            originalname: files[i].name,
            size: files[i].size,
            blobContainer: blobContainerName,
            blobName,
            mimetype: files[i].type,
          };
          propertyImages.push(blobItem);
        }
      } catch (err) {
        toast.error("Something went wrong");
        console.log(err);
      }
    }
    if (propertyImageAttachments.length > 0)
      setPropertyImageAttachments(
        propertyImageAttachments.concat(propertyImages),
      );
    else setPropertyImageAttachments(propertyImages);
  };
  const removePropertyImageAttachments = (serverfilename) => {
    const filteredAttachments = propertyImageAttachments.filter((item) => {
      return item.blobName !== serverfilename;
    });
    setPropertyImageAttachments(filteredAttachments);
  };
  const updateThumbnail = async (thumbnail) => {
    if (thumbnail.blobName !== undefined) {
      try {
        const azureDownloadresult = await downloadBlobFile(
          blobContainerName,
          thumbnail.blobName,
          thumbnail.originalname,
        );
        if (azureDownloadresult.status === "success") {
          const azureData = azureDownloadresult.data;
          setThumbnailImage(azureData);
        }
      } catch (err) {
        toast.error("Cloud Storage Error");
        console.log(err);
      }
    }
  };

  const uploadThumbnail = async (files) => {
    toast.success("Uploading thumbnail");
    const fileExtension = files[0].name.split(".")[1];
    const blobName =
      CryptoJS.AES.encrypt(
        files[0].name + Date.now().toString(),
        process.env.REACT_APP_CIPHER_CODE,
      )
        .toString()
        .replace(/[^a-zA-Z0-9_]/g, "") + ".crypt";
    // + fileExtension;
    try {
      const uploadBlobResult = await uploadBlobToContainer(
        blobContainerName,
        blobName,
        files[0],
      );
      if (uploadBlobResult.status === "success") {
        const thumbnail = {
          originalname: files[0].name,
          size: files[0].size,
          blobContainer: blobContainerName,
          blobName,
          mimetype: files[0].type,
        };
        setThumbnail(thumbnail);
        updateThumbnail(thumbnail);
      }
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    setMarkerCoordinates({
      lat: 11.0083592,
      lng: 76.9746159,
    });
    getServiceTicketDetails();
  }, []);

  return (
    <>
      <div className='min-h-full'>
        <main className='relative'>
          <div className='max-w-8xl mx-auto py-6 sm:px-6 lg:px-8'>
            <div className='px-4 py-0 sm:px-0'>
              <div className='block'>
                <form
                  action='#'
                  method='POST'
                  noValidate
                  onSubmit={(event) => {
                    event.preventDefault();
                    handleSubmit(event);
                  }}>
                  <TailwindToaster />
                  <div className='shadow overflow-hidden sm:rounded-sm'>
                    <div className='px-4 py-5 bg-gray-50 sm:p-6'>
                      <div className='lg:items-center justify-between'>
                        <div className='flex-1 min-w-0 px-0 lg:px-0'>
                          <h2 className='text-xl font-semibold leading-3 text-gray-dark sm:text-xl '>
                            Property Information Form
                          </h2>
                        </div>
                      </div>
                      <div className='mt-2 grid grid-cols-12 gap-2 bg-yellow-50 rounded-sm p-4'>
                        <div className='col-span-12 min-w-0 px-0 lg:px-0'>
                          <h2 className='text-lg font-semibold leading-3 text-gray-dark '>
                            Basic Details
                          </h2>
                        </div>
                        <div className='col-span-12 sm:col-span-12'>
                          <label
                            htmlFor='neightbouringArea'
                            className='block text-sm font-medium text-gray-700'>
                            Neighbouring Area
                          </label>
                          <select
                            id='neightbouringArea'
                            name='neightbouringArea'
                            className='mt-0 block w-full sm:w-2/12 py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                            <option value=''>Select</option>
                            <option value='Residential'>Residential</option>
                            <option value='Industrial'>Industrial</option>
                            <option value='Commercial'>Commercial</option>
                            <option value='Educational'>Educational</option>
                            <option value='Others'>Others</option>
                          </select>
                        </div>
                        <div className='col-span-12 rounded-sm'>
                          {markerCoordinates.lat ? (
                            <GmapsComponent
                              zoom={10}
                              position={markerCoordinates}
                              draggableMarker={true}
                              onPositionChanged={updatedMarkerPosition}
                            />
                          ) : (
                            <></>
                          )}
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='longitude'
                            className={`block text-sm font-medium ${
                              !validLongitude ? "text-red-600" : "text-gray-700"
                            }`}>
                            Longitude
                          </label>
                          <input
                            type='number'
                            name='longitude'
                            id='longitude'
                            maxLength='15'
                            className={`mt-0 ${
                              !validLongitude
                                ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                : "focus:ring-yellow-2 focus:border-yellow-2"
                            }  block w-full shadow-sm sm:text-sm  rounded-sm`}
                          />
                          {!validLongitude && (
                            <p className='text-red-600 text-sm'>
                              Longitude invalid
                            </p>
                          )}
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='latitude'
                            className={`block text-sm font-medium ${
                              !validLatitude ? "text-red-600" : "text-gray-700"
                            }`}>
                            Latitude
                          </label>
                          <input
                            type='number'
                            name='latitude'
                            id='latitude'
                            maxLength='15'
                            className={`mt-0 ${
                              !validLatitude
                                ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                : "focus:ring-yellow-2 focus:border-yellow-2"
                            }  block w-full shadow-sm sm:text-sm  rounded-sm`}
                          />
                          {!validLatitude && (
                            <p className='text-red-600 text-sm'>
                              Latitude invalid
                            </p>
                          )}
                        </div>
                        <div className='col-span-12 sm:col-span-6 '>
                          <label
                            htmlFor='landmark'
                            className={`block text-sm font-medium ${
                              !validLandmark ? "text-red-600" : "text-gray-700"
                            }`}>
                            Landmark
                          </label>
                          <input
                            type='text'
                            name='landmark'
                            id='landmark'
                            maxLength='100'
                            className={`mt-0 ${
                              !validLandmark
                                ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                : "focus:ring-yellow-2 focus:border-yellow-2"
                            }  block w-full shadow-sm sm:text-sm  rounded-sm`}
                          />
                          {!validLandmark && (
                            <p className='text-red-600 text-sm'>
                              Landmark invalid
                            </p>
                          )}
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='price'
                            className={`block text-sm font-medium ${
                              !validPrice ? "text-red-600" : "text-gray-700"
                            }`}>
                            Price
                          </label>
                          <input
                            type='tel'
                            name='price'
                            id='price'
                            maxLength='13'
                            className={`mt-0 ${
                              !validPrice
                                ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                : "focus:ring-yellow-2 focus:border-yellow-2"
                            }  block w-full shadow-sm sm:text-sm  rounded-sm`}
                          />
                          {!validPrice && (
                            <p className='text-red-600 text-sm'>
                              Price invalid
                            </p>
                          )}
                        </div>
                        <div className='col-span-12 sm:col-span-5 '>
                          <label
                            htmlFor='addressline1'
                            className={`block text-sm font-medium ${
                              !validAddress1 ? "text-red-600" : "text-gray-700"
                            }`}>
                            Address Line 1
                          </label>
                          <input
                            type='text'
                            name='addressline1'
                            id='addressline1'
                            maxLength='100'
                            className={`mt-0 ${
                              !validAddress1
                                ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                : "focus:ring-yellow-2 focus:border-yellow-2"
                            }  block w-full shadow-sm sm:text-sm  rounded-sm`}
                          />
                          {!validAddress1 && (
                            <p className='text-red-600 text-sm'>
                              Address Line 1 invalid
                            </p>
                          )}
                        </div>
                        <div className='col-span-12 sm:col-span-4'>
                          <label
                            htmlFor='addressline2'
                            className={`block text-sm font-medium ${
                              !validAddress2 ? "text-red-600" : "text-gray-700"
                            }`}>
                            Address Line 2
                          </label>
                          <input
                            type='text'
                            name='addressline2'
                            id='addressline2'
                            maxLength='100'
                            className={`mt-0 ${
                              !validAddress2
                                ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                : "focus:ring-yellow-2 focus:border-yellow-2"
                            }  block w-full shadow-sm sm:text-sm  rounded-sm`}
                          />
                          {!validAddress2 && (
                            <p className='text-red-600 text-sm'>
                              Address Line 2 invalid
                            </p>
                          )}
                        </div>
                        <div className='col-span-12 sm:col-span-3'>
                          <label
                            htmlFor='propertyLocation'
                            className={`block text-sm font-medium text-gray-700`}>
                            Location (For Filters)
                          </label>
                          <Multiselect
                            className={`mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm`}
                            options={propertyLocationsData}
                            selectedValues={pifLocationsSelectedData}
                            onSelect={(selectedList, selectedItem) => {
                              selectedList.map((item) => {
                                delete item["validflag"];
                                delete item["createdAt"];
                                delete item["updatedAt"];
                              });
                              setPifLocationsSelectedData(selectedList);
                              const pifLocationIds = [];
                              selectedList.map((item) => {
                                pifLocationIds.push(item._id);
                              });
                              setPIFLocations(pifLocationIds);
                            }}
                            onRemove={(selectedList, removedItem) => {
                              selectedList.map((item) => {
                                delete item["validflag"];
                                delete item["createdAt"];
                                delete item["updatedAt"];
                              });
                              setPifLocationsSelectedData(selectedList);
                              const pifLocationIds = [];
                              selectedList.map((item) => {
                                pifLocationIds.push(item._id);
                              });
                              setPIFLocations(pifLocationIds);
                            }}
                            displayValue='name'
                            style={{
                              chips: {
                                background: "#dea302",
                                borderRadius: "2pt",
                              },
                              multiselectContainer: {
                                color: "#dea302",
                              },
                              inputField: {
                                "font-size": "13px",
                                padding: "3px 5px 3px 7px",
                                width: "100%",
                                border: "none",
                                boxShadow: "none",
                              },
                              searchBox: {
                                border: "none",
                                "font-size": "5px",
                                background: "#fff",
                              },
                            }}
                          />
                        </div>
                        <div className='col-span-6 sm:col-span-4'>
                          <label
                            htmlFor='city'
                            className={`block text-sm font-medium ${
                              !validCity ? "text-red-600" : "text-gray-700"
                            }`}>
                            City
                          </label>
                          <input
                            type='text'
                            name='city'
                            id='city'
                            maxLength='30'
                            className={`mt-0 ${
                              !validCity
                                ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                : "focus:ring-yellow-2 focus:border-yellow-2"
                            }  block w-full shadow-sm sm:text-sm  rounded-sm`}
                          />
                          {!validCity && (
                            <p className='text-red-600 text-sm'>City invalid</p>
                          )}
                        </div>

                        <div className='col-span-6 sm:col-span-3'>
                          <label
                            htmlFor='state'
                            className={`block text-sm font-medium ${
                              !validState ? "text-red-600" : "text-gray-700"
                            }`}>
                            State
                          </label>
                          <input
                            type='text'
                            name='state'
                            id='state'
                            maxLength='30'
                            className={`mt-0 ${
                              !validState
                                ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                : "focus:ring-yellow-2 focus:border-yellow-2"
                            }  block w-full shadow-sm sm:text-sm  rounded-sm`}
                          />
                          {!validState && (
                            <p className='text-red-600 text-sm'>
                              State invalid
                            </p>
                          )}
                        </div>
                        <div className='col-span-6 sm:col-span-3'>
                          <label
                            htmlFor='country'
                            className={`block text-sm font-medium ${
                              !validCountry ? "text-red-600" : "text-gray-700"
                            }`}>
                            Country
                          </label>
                          <input
                            type='text'
                            name='country'
                            id='country'
                            maxLength='30'
                            className={`mt-0 ${
                              !validCountry
                                ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                : "focus:ring-yellow-2 focus:border-yellow-2"
                            }  block w-full shadow-sm sm:text-sm  rounded-sm`}
                          />
                          {!validCountry && (
                            <p className='text-red-600 text-sm'>
                              Country invalid
                            </p>
                          )}
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='pin_code'
                            className={`block text-sm font-medium ${
                              !validPincode ? "text-red-600" : "text-gray-700"
                            }`}>
                            Pincode
                          </label>
                          <input
                            type='tel'
                            name='pin_code'
                            id='pin_code'
                            maxLength='6'
                            className={`mt-0 ${
                              !validPincode
                                ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                : "focus:ring-yellow-2 focus:border-yellow-2"
                            }  block w-full shadow-sm sm:text-sm  rounded-sm`}
                          />
                          {!validPincode && (
                            <p className='text-red-600 text-sm'>
                              Pincode invalid
                            </p>
                          )}
                        </div>
                      </div>
                      <div className='mt-3 grid grid-cols-12 gap-2 bg-gray-100 rounded-sm p-4'>
                        <div className='col-span-12 flex-1 min-w-0 px-0 lg:px-0'>
                          <h2 className='text-lg font-semibold leading-3 text-gray-dark '>
                            Specification
                          </h2>
                        </div>
                        <div className='col-span-12 sm:col-span-3'>
                          <label
                            htmlFor='locationType'
                            className='block text-sm font-medium text-gray-700'>
                            Location Type
                          </label>
                          <select
                            id='locationType'
                            name='locationType'
                            className='mt-0 block w-full py-2 px-3 border  bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                            <option value=''>Select</option>
                            <option value='Developed'>Developed</option>
                            <option value='Porch'>Porch</option>
                            <option value='Developing'>Developing</option>
                            <option value='Slum'>Slum</option>
                            <option value='Others'>Others</option>
                          </select>
                        </div>
                        <div className='col-span-12 sm:col-span-4'>
                          <label
                            htmlFor='shape'
                            className='block text-sm font-medium text-gray-700'>
                            Shape
                          </label>
                          <select
                            id='shape'
                            name='shape'
                            className='mt-0 block w-full py-2 px-3 border  bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                            <option value=''>Select</option>
                            <option value='Square'>Square</option>
                            <option value='Square and Cross'>
                              Square and Cross
                            </option>
                            <option value='Square and Corner Site'>
                              Square and Corner Site
                            </option>
                            <option value='Square and White Splay'>
                              Square and White Splay
                            </option>
                            <option value='Rectangle'>Rectangle</option>
                            <option value='Rectangle and Cross'>
                              Rectangle and Cross
                            </option>
                            <option value='Rectangle and Corner Site'>
                              Rectangle and Corner Site
                            </option>
                            <option value='Rectangle with Splay'>
                              Rectangle with Splay
                            </option>
                            <option value='Others'>Others</option>
                          </select>
                        </div>
                        <div className='col-span-12 sm:col-span-3'>
                          <label
                            htmlFor='approachRoadSize'
                            className='block text-sm font-medium text-gray-700'>
                            Approach Road Size (cms)
                          </label>
                          <input
                            type='tel'
                            name='approachRoadSize'
                            id='approachRoadSize'
                            maxLength='30'
                            className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                          />
                        </div>
                        <div className='col-span-12 sm:col-span-2'>
                          <label
                            htmlFor='roadType'
                            className='block text-sm font-medium text-gray-700'>
                            Road Type
                          </label>
                          <select
                            id='roadType'
                            name='roadType'
                            className='mt-0 block w-full py-2 px-3 border  bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                            <option value=''>Select</option>
                            <option value='Mud'>Mud</option>
                            <option value='Tar'>Tar</option>
                            <option value='Concrete'>Concrete</option>
                            <option value='Metal'>Metal</option>
                            <option value='Others'>Others</option>
                          </select>
                        </div>
                        <div className='col-span-12 sm:col-span-5'>
                          <label
                            htmlFor='frontage'
                            className='block text-sm font-medium text-gray-700'>
                            Frontage
                          </label>
                          <input
                            type='text'
                            name='frontage'
                            id='frontage'
                            maxLength='100'
                            className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                          />
                        </div>
                        <div className='col-span-6 sm:col-span-5'>
                          <label
                            htmlFor='surroundingDetails'
                            className='block text-sm font-medium text-gray-700'>
                            Surrounding Details
                          </label>
                          <input
                            type='text'
                            name='surroundingDetails'
                            id='surroundingDetails'
                            maxLength='100'
                            className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                          />
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='roadKuthal'
                            className='block text-sm font-medium text-gray-700'>
                            Road Kuthal
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-16 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={roadKuthalEnabled}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setRoadKuthalEnabled(!roadKuthalEnabled);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className='mt-3 grid grid-cols-12 gap-2 bg-yellow-50 rounded-sm p-4'>
                        <div className='col-span-12 flex-1 min-w-0 px-0 lg:px-0'>
                          <h2 className='text-lg font-semibold leading-3 text-gray-dark '>
                            Documents &amp; Miscellaneous
                          </h2>
                        </div>
                        <div className='col-span-12 sm:col-span-3'>
                          <label
                            htmlFor='propertyNumber'
                            className='block text-sm font-medium text-gray-700'>
                            Property Number
                          </label>
                          <input
                            type='text'
                            name='propertyNumber'
                            id='propertyNumber'
                            maxLength='10'
                            className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm rounded-sm'
                          />
                        </div>
                        <div className='col-span-12 sm:col-span-3'>
                          <label
                            htmlFor='propertyNumberType'
                            className='block text-sm font-medium text-gray-700'>
                            Property Number Type
                          </label>
                          <select
                            id='propertyNumberType'
                            name='propertyNumberType'
                            className='mt-0 block w-full py-2 px-3 border  bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                            <option value=''>Select</option>
                            <option value='S.F'>S.F</option>
                            <option value='T.S'>T.S</option>
                            <option value='R.S'>R.S</option>
                            <option value='S.F-T.S'>S.F-T.S</option>
                            <option value='Others'>Others</option>
                          </select>
                        </div>
                        <div className='col-span-12 sm:col-span-3'>
                          <label
                            htmlFor='guideLineValue'
                            className='block text-sm font-medium text-gray-700'>
                            Guide - Line Value
                          </label>
                          <input
                            type='tel'
                            name='guideLineValue'
                            id='guideLineValue'
                            maxLength='30'
                            className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                          />
                        </div>
                        <div className='col-span-6 sm:col-span-3'>
                          <label
                            htmlFor='approvalAuthority'
                            className='block text-sm font-medium text-gray-700'>
                            Approval Authority
                          </label>
                          <select
                            id='approvalAuthority'
                            name='approvalAuthority'
                            className='mt-0 block w-full py-2 px-3 border  bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                            <option value=''>Select</option>
                            <option value='Corporation'>Corporation</option>
                            <option value='Panchayath'>Panchayath</option>
                            <option value='Schema'>Schema</option>
                            <option value='LPA'>LPA</option>
                            <option value='Others'>Others</option>
                          </select>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='approvalType'
                            className='block text-sm font-medium text-gray-700'>
                            Approval Type
                          </label>
                          <select
                            id='approvalType'
                            name='approvalType'
                            className='mt-0 block w-full py-2 px-3 border  bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                            <option value=''>Select</option>
                            <option value='Approved'>Approved</option>
                            <option value='Unapproved'>Unapproved</option>
                          </select>
                        </div>
                        <div className='col-span-12 sm:col-span-5'>
                          <label
                            htmlFor='villageName'
                            className='block text-sm font-medium text-gray-700'>
                            Village Name
                          </label>
                          <input
                            type='text'
                            name='villageName'
                            id='villageName'
                            maxLength='100'
                            className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                          />
                        </div>

                        <div className='col-span-12 sm:col-span-3'>
                          <label
                            htmlFor='sroName'
                            className='block text-sm font-medium text-gray-700'>
                            SRO Name
                          </label>
                          <input
                            type='text'
                            name='sroName'
                            id='sroName'
                            maxLength='100'
                            className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                          />
                        </div>
                        <div className='col-span-12 sm:col-span-2'>
                          <label
                            htmlFor='approvalNumber'
                            className='block text-sm font-medium text-gray-700'>
                            Approval Number
                          </label>
                          <input
                            type='tel'
                            name='approvalNumber'
                            id='approvalNumber'
                            maxLength='5'
                            className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                          />
                        </div>
                        <div className='col-span-12 sm:col-span-3'>
                          <label
                            htmlFor='talukName'
                            className='block text-sm font-medium text-gray-700'>
                            Taluk Name
                          </label>
                          <input
                            type='text'
                            name='talukName'
                            id='talukName'
                            maxLength='50'
                            className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                          />
                        </div>
                        <div className='col-span-12 sm:col-span-3'>
                          <label
                            htmlFor='accusationPossibility'
                            className='block text-sm font-medium text-gray-700'>
                            Accusation Possibility
                          </label>
                          <input
                            type='text'
                            name='accusationPossibility'
                            id='accusationPossibility'
                            maxLength='100'
                            className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                          />
                        </div>
                        <div className='col-span-12 sm:col-span-3'>
                          <label
                            htmlFor='accusationPossibilityOther'
                            className='block text-sm font-medium text-gray-700'>
                            Accusation Possibility Other
                          </label>
                          <input
                            type='text'
                            name='accusationPossibilityOther'
                            id='accusationPossibilityOther'
                            maxLength='100'
                            className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                          />
                        </div>
                        <div className='col-span-6 sm:col-span-1'>
                          <label
                            htmlFor='loanable'
                            className='block text-sm font-medium text-gray-700'>
                            Loanable
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-16 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={loanableEnabled}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setLoanableEnabled(!loanableEnabled);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Publish Ad in Website?
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={websitePublish}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setwebsitePublish(!websitePublish);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                      </div>

                      {buildingList.includes(propertySubType.toLowerCase()) && (
                        <div className='mt-3 grid grid-cols-12 gap-2 bg-gray-100 rounded-sm p-4'>
                          <div className='col-span-12 flex-1 min-w-0 px-0 lg:px-0'>
                            <h2 className='text-lg font-semibold leading-3 text-gray-dark '>
                              Building / Land Details
                            </h2>
                          </div>
                          <div className='col-span-12 sm:col-span-2'>
                            <label
                              htmlFor='constructedArea'
                              className='block text-sm font-medium text-gray-700'>
                              Constructed Area
                            </label>
                            <input
                              type='tel'
                              name='constructedArea'
                              id='constructedArea'
                              maxLength='3'
                              className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm rounded-sm'
                            />
                          </div>
                          <div className='col-span-12 sm:col-span-2'>
                            <label
                              htmlFor='carpetArea'
                              className='block text-sm font-medium text-gray-700'>
                              Carpet Area
                            </label>
                            <input
                              type='tel'
                              name='carpetArea'
                              id='carpetArea'
                              maxLength='3'
                              className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm rounded-sm'
                            />
                          </div>
                          <div className='col-span-12 sm:col-span-2'>
                            <label
                              htmlFor='areaUnitValue'
                              className='block text-sm font-medium text-gray-700'>
                              Area Measurement Value
                            </label>
                            <input
                              type='tel'
                              name='areaUnitValue'
                              id='areaUnitValue'
                              maxLength='6'
                              className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                            />
                          </div>
                          <div className='col-span-12 sm:col-span-2'>
                            <label
                              htmlFor='areaUnit'
                              className='block text-sm font-medium text-gray-700'>
                              Area Unit
                            </label>
                            <select
                              id='areaUnit'
                              name='areaUnit'
                              className='mt-0 block w-full py-2 px-3 border  bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                              <option value=''>Select</option>
                              <option value='acre'>acre</option>
                              <option value='cent'>cent</option>
                            </select>
                          </div>
                          <div className='col-span-6 sm:col-span-2'>
                            <label
                              htmlFor='vastuCompliance'
                              className='block text-sm font-medium text-gray-700'>
                              Vastu Compliance
                            </label>
                            <div className='flex mt-2'>
                              <label className='ml-16 relative items-center cursor-pointer'>
                                <input
                                  type='checkbox'
                                  className='sr-only peer '
                                  checked={vastuComplianceEnabled}
                                  readOnly
                                />
                                <div
                                  onClick={() => {
                                    setVastuComplianceEnabled(
                                      !vastuComplianceEnabled,
                                    );
                                  }}
                                  className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                              </label>
                            </div>
                          </div>
                          <div className='col-span-6 sm:col-span-2'>
                            <label
                              htmlFor='facing'
                              className='block text-sm font-medium text-gray-700'>
                              Facing
                            </label>
                            <select
                              id='facing'
                              name='facing'
                              defaultValue={facing}
                              className='mt-0 block w-full py-2 px-3 border  bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                              <option value=''>Select</option>
                              <option value='North'>North</option>
                              <option value='South'>South</option>
                              <option value='West'>West</option>
                              <option value='East'>East</option>
                              <option value='North-East'>North-East</option>
                              <option value='North-West'>North-West</option>
                              <option value='South-East'>South-East</option>
                              <option value='South-West'>South-West</option>
                              <option value='North and South'>
                                North and South
                              </option>
                              <option value='East and West'>
                                East and West
                              </option>
                              <option value='Others'>Others</option>
                            </select>
                          </div>
                          <div className='col-span-6 sm:col-span-2'>
                            <label
                              htmlFor='buildingFloors'
                              className='block text-sm font-medium text-gray-700'>
                              Building Floors
                            </label>
                            <select
                              id='buildingFloors'
                              name='buildingFloors'
                              defaultValue={buildingFloors}
                              className='mt-0 block w-full py-2 px-3 border  bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                              <option value=''>Select</option>
                              <option value='1'>1</option>
                              <option value='2'>2</option>
                              <option value='3'>3</option>
                              <option value='4'>4</option>
                              <option value='5'>5</option>
                              <option value='6'>6</option>
                              <option value='7'>7</option>
                              <option value='8'>8</option>
                              <option value='9'>9</option>
                              <option value='10'>10</option>
                            </select>
                          </div>
                          <div className='col-span-6 sm:col-span-2'>
                            <label
                              htmlFor='buidlingAge'
                              className='block text-sm font-medium text-gray-700'>
                              Building Age
                            </label>
                            <select
                              id='buidlingAge'
                              name='buidlingAge'
                              className='mt-0 block w-full py-2 px-3 border  bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                              <option value=''>Select</option>
                              <option value='0-1 yrs'>0-1</option>
                              <option value='1-5 yrs'>1-5</option>
                              <option value='5-10 yrs'>5-10</option>
                              <option value='10+ yrs'>10+</option>
                            </select>
                          </div>

                          <div className='col-span-12 sm:col-span-2'>
                            <label
                              htmlFor='landSizeValue'
                              className='block text-sm font-medium text-gray-700'>
                              Land Size Value
                            </label>
                            <input
                              type='tel'
                              name='landSizeValue'
                              id='landSizeValue'
                              maxLength='3'
                              className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                            />
                          </div>
                          <div className='col-span-6 sm:col-span-2'>
                            <label
                              htmlFor='landExistingUse'
                              className='block text-sm font-medium text-gray-700'>
                              Land Existing Use
                            </label>
                            <select
                              id='landExistingUse'
                              name='landExistingUse'
                              className='mt-0 block w-full py-2 px-3 border  bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                              <option value=''>Select</option>
                              <option value='Residential'>Residential</option>
                              <option value='Industrial'>Industrial</option>
                              <option value='Commercial'>Commercial</option>
                              <option value='Educational'>Educational</option>
                              <option value='Agricultural'>Agricultural</option>
                              <option value='Others'>Others</option>
                            </select>
                          </div>
                          <div className='col-span-6 sm:col-span-2'>
                            <label
                              htmlFor='dimensions'
                              className='block text-sm font-medium text-gray-700'>
                              Dimensions
                            </label>
                            <input
                              type='text'
                              name='dimensions'
                              id='dimensions'
                              maxLength='30'
                              className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                            />
                          </div>
                          <div className='col-span-6 sm:col-span-4'>
                            <label
                              htmlFor=''
                              className='block text-sm font-medium text-gray-700'>
                              Physical Measurement Taken
                            </label>
                            <div className='flex mt-2'>
                              <label className='ml-16 relative items-center cursor-pointer'>
                                <input
                                  type='checkbox'
                                  className='sr-only peer '
                                  checked={physicalMeasurementEnabled}
                                  readOnly
                                />
                                <div
                                  onClick={() => {
                                    setPhysicalMeasurementEnabled(
                                      !physicalMeasurementEnabled,
                                    );
                                  }}
                                  className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                              </label>
                            </div>
                          </div>
                          <div className='col-span-6 sm:col-span-2'>
                            <label
                              htmlFor='solidType'
                              className='block text-sm font-medium text-gray-700'>
                              Soil Type
                            </label>
                            <select
                              id='solidType'
                              name='solidType'
                              className='mt-0 block w-full py-2 px-3 border  bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                              <option value=''>Select</option>
                              <option value='Red'>Red</option>
                              <option value='Black'>Black</option>
                              <option value='Fertile'>Fertile</option>
                              <option value='Clay'>Clay</option>
                              <option value='Rocky'>Rocky</option>
                              <option value='Others'>Others</option>
                            </select>
                          </div>
                          <div className='col-span-6 sm:col-span-3'>
                            <label
                              htmlFor=''
                              className='block text-sm font-medium text-gray-700'>
                              Ground Water Availability
                            </label>
                            <div className='flex mt-2'>
                              <label className='ml-16 relative items-center cursor-pointer'>
                                <input
                                  type='checkbox'
                                  className='sr-only peer '
                                  checked={groundWaterEnabled}
                                  readOnly
                                />
                                <div
                                  onClick={() => {
                                    setGroundWaterEnabled(!groundWaterEnabled);
                                  }}
                                  className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                              </label>
                            </div>
                          </div>
                          <div className='col-span-6 sm:col-span-3'>
                            <label
                              htmlFor='groundWaterType'
                              className='block text-sm font-medium text-gray-700'>
                              Ground Water Type
                            </label>
                            <select
                              id='groundWaterType'
                              name='groundWaterType'
                              className='mt-0 block w-full py-2 px-3 border  bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                              <option value=''>Select</option>
                              <option value='Drinking'>Drinking</option>
                              <option value='Salt Water'>Salt Water</option>
                              <option value='Semi Salt'>Semi Salt</option>
                              <option value='Others'>Others</option>
                            </select>
                          </div>
                          <div className='col-span-12 sm:col-span-3'>
                            <label
                              htmlFor='groundWaterLevel'
                              className='block text-sm font-medium text-gray-700'>
                              Ground Water Level
                            </label>
                            <input
                              type='text'
                              name='groundWaterLevel'
                              id='groundWaterLevel'
                              maxLength='30'
                              className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                            />
                          </div>
                        </div>
                      )}
                      {!buildingList.includes(
                        propertySubType.toLowerCase(),
                      ) && (
                        <div className='mt-3 grid grid-cols-12 gap-2 bg-gray-100 rounded-sm p-4'>
                          <div className='col-span-12 flex-1 min-w-0 px-0 lg:px-0'>
                            <h2 className='text-lg font-semibold leading-3 text-gray-dark '>
                              Building / Land Details
                            </h2>
                          </div>
                          <div className='col-span-6 sm:col-span-2'>
                            <label
                              htmlFor='floorAllowedToConstruct'
                              className='block text-sm font-medium text-gray-700'>
                              Floors Allowed To Construct
                            </label>
                            <select
                              id='floorAllowedToConstruct'
                              name='floorAllowedToConstruct'
                              className='mt-0 block w-full py-2 px-3 border  bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                              <option value=''>Select</option>
                              <option value='1'>1</option>
                              <option value='2'>2</option>
                              <option value='3'>3</option>
                              <option value='4'>4</option>
                              <option value='5'>5</option>
                              <option value='6'>6</option>
                              <option value='7'>7</option>
                              <option value='8'>8</option>
                              <option value='9'>9</option>
                              <option value='10'>10</option>
                            </select>
                          </div>
                          <div className='col-span-6 sm:col-span-3'>
                            <label
                              htmlFor='undividedShareValue'
                              className='block text-sm font-medium text-gray-700'>
                              Undivided Share Value
                            </label>
                            <input
                              type='text'
                              name='undividedShareValue'
                              id='undividedShareValue'
                              maxLength='100'
                              className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                            />
                          </div>
                          <div className='col-span-12 sm:col-span-2'>
                            <label
                              htmlFor='areaUnitValue'
                              className='block text-sm font-medium text-gray-700'>
                              Area Measurement Value
                            </label>
                            <input
                              type='tel'
                              name='areaUnitValue'
                              id='areaUnitValue'
                              maxLength='6'
                              className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                            />
                          </div>
                          <div className='col-span-12 sm:col-span-2'>
                            <label
                              htmlFor='areaUnit'
                              className='block text-sm font-medium text-gray-700'>
                              Area Unit
                            </label>
                            <select
                              id='areaUnit'
                              name='areaUnit'
                              className='mt-0 block w-full py-2 px-3 border  bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                              <option value=''>Select</option>
                              <option value='acre'>acre</option>
                              <option value='cent'>cent</option>
                            </select>
                          </div>
                        </div>
                      )}
                      <div className='mt-3 grid grid-cols-12 gap-2 bg-yellow-50 rounded-sm p-4'>
                        <div className='col-span-12 flex-1 min-w-0 px-0 lg:px-0'>
                          <h2 className='text-lg font-semibold leading-3 text-gray-dark '>
                            Hindrance &amp; Comments
                          </h2>
                        </div>
                        <div className='col-span-6 sm:col-span-1'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            EB HT
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={ebhtEnabled}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setebhtEnabled(!ebhtEnabled);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div
                          className={`col-span-6 sm:col-span-2 ${
                            ebhtEnabled ? "opacity-100" : "opacity-20"
                          } duration-300`}>
                          <label
                            htmlFor='ebhtDistance'
                            className='block text-sm font-medium text-gray-700'>
                            EB HT Distance
                          </label>
                          <input
                            type='text'
                            name='ebhtDistance'
                            id='ebhtDistance'
                            maxLength='100'
                            className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                          />
                        </div>
                        <div className='col-span-6 sm:col-span-1'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            EB LT
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={ebltEnabled}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setebltEnabled(!ebltEnabled);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div
                          className={`col-span-6 sm:col-span-2 ${
                            ebltEnabled ? "opacity-100" : "opacity-20"
                          } duration-300`}>
                          <label
                            htmlFor='ebltDistance'
                            className='block text-sm font-medium text-gray-700'>
                            EB LT Distance
                          </label>
                          <input
                            type='text'
                            name='ebltDistance'
                            id='ebltDistance'
                            maxLength='100'
                            className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                          />
                        </div>
                        <div className='col-span-6 sm:col-span-1'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Temple
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={templeEnabled}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  settempleEnabled(!templeEnabled);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div
                          className={`col-span-6 sm:col-span-2 ${
                            templeEnabled ? "opacity-100" : "opacity-20"
                          } duration-300`}>
                          <label
                            htmlFor='templeDistance'
                            className='block text-sm font-medium text-gray-700'>
                            Temple Distance
                          </label>
                          <input
                            type='text'
                            name='templeDistance'
                            id='templeDistance'
                            maxLength='100'
                            className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                          />
                        </div>
                        <div className='col-span-6 sm:col-span-1'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Water
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={waterEnabled}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setwaterEnabled(!waterEnabled);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div
                          className={`col-span-6 sm:col-span-2 ${
                            waterEnabled ? "opacity-100" : "opacity-20"
                          } duration-300`}>
                          <label
                            htmlFor='waterDistance'
                            className='block text-sm font-medium text-gray-700'>
                            Water Distance
                          </label>
                          <input
                            type='text'
                            name='waterDistance'
                            id='waterDistance'
                            maxLength='100'
                            className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                          />
                        </div>
                        <div className='col-span-6 sm:col-span-1'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Burial Ground
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={burialGroundEnabled}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setburialGroundEnabled(!burialGroundEnabled);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div
                          className={`col-span-6 sm:col-span-3 ${
                            burialGroundEnabled ? "opacity-100" : "opacity-20"
                          } duration-300`}>
                          <label
                            htmlFor='burialGroundDistance'
                            className='block text-sm font-medium text-gray-700'>
                            Burial Ground Distance
                          </label>
                          <input
                            type='text'
                            name='burialGroundDistance'
                            id='burialGroundDistance'
                            maxLength='100'
                            className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                          />
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Railway Track
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={railwayTrackEnabled}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setrailwayTrackEnabled(!railwayTrackEnabled);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div
                          className={`col-span-6 sm:col-span-3 ${
                            railwayTrackEnabled ? "opacity-100" : "opacity-20"
                          } duration-300`}>
                          <label
                            htmlFor='railwayTrackDistance'
                            className='block text-sm font-medium text-gray-700'>
                            Railway Track Distance
                          </label>
                          <input
                            type='text'
                            name='railwayTrackDistance'
                            id='railwayTrackDistance'
                            maxLength='100'
                            className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                          />
                        </div>
                        <div className='hidden sm:col-span-1 sm:block'></div>
                        <div className='col-span-3 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Poramboke
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={porambokeEnabled}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setporambokeEnabled(!porambokeEnabled);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-3 sm:col-span-1'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Quarry
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={quarryEnabled}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setquarryEnabled(!quarryEnabled);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div
                          className={`col-span-6 sm:col-span-2 ${
                            quarryEnabled ? "opacity-100" : "opacity-20"
                          } duration-300`}>
                          <label
                            htmlFor='quarryDistance'
                            className='block text-sm font-medium text-gray-700'>
                            Quarry Distance
                          </label>
                          <input
                            type='text'
                            name='quarryDistance'
                            id='quarryDistance'
                            maxLength='100'
                            className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                          />
                        </div>
                        <div className='col-span-12 sm:col-span-5'>
                          <label
                            htmlFor='advantages'
                            className='block text-sm font-medium text-gray-700'>
                            Advantages
                          </label>
                          <input
                            type='text'
                            name='advantages'
                            id='advantages'
                            maxLength='100'
                            className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                          />
                        </div>
                        <div className='col-span-12 sm:col-span-4'>
                          <label
                            htmlFor='opinion'
                            className='block text-sm font-medium text-gray-700'>
                            Opinion
                          </label>
                          <input
                            type='text'
                            name='opinion'
                            id='opinion'
                            maxLength='100'
                            className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                          />
                        </div>
                        <div className='col-span-12'>
                          <label
                            htmlFor='remarks'
                            className='block text-sm font-medium text-gray-700'>
                            Remarks
                          </label>
                          <input
                            type='text'
                            name='remarks'
                            id='remarks'
                            maxLength='100'
                            className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full sm:w-6/12 shadow-sm sm:text-sm  rounded-sm'
                          />
                        </div>
                      </div>
                      <div className='mt-3 grid grid-cols-12 gap-3 bg-gray-100 rounded-sm p-4'>
                        <div className='col-span-12 flex-1 min-w-0 px-0 lg:px-0'>
                          <h2 className='text-lg font-semibold leading-3 text-gray-dark '>
                            Amenities
                          </h2>
                        </div>
                        <div className='col-span-6 sm:col-span-3'>
                          <label
                            htmlFor='bedroomWithBalcony'
                            className='block text-sm font-medium text-gray-700'>
                            Bedroom with Balcony
                          </label>
                          <select
                            id='bedroomWithBalcony'
                            name='bedroomWithBalcony'
                            className='mt-0 block w-full py-2 px-3 border  bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                            <option value=''>Select</option>
                            <option value='0'>0</option>
                            <option value='1'>1</option>
                            <option value='2'>2</option>
                            <option value='3'>3</option>
                            <option value='4'>4</option>
                          </select>
                        </div>
                        <div className='col-span-6 sm:col-span-3'>
                          <label
                            htmlFor='hallWithBalcony'
                            className='block text-sm font-medium text-gray-700'>
                            Hall with Balcony
                          </label>
                          <select
                            id='hallWithBalcony'
                            name='hallWithBalcony'
                            className='mt-0 block w-full py-2 px-3 border  bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                            <option value=''>Select</option>
                            <option value='0'>0</option>
                            <option value='1'>1</option>
                            <option value='2'>2</option>
                            <option value='3'>3</option>
                            <option value='4'>4</option>
                          </select>
                        </div>
                        <div className='col-span-6 sm:col-span-3'>
                          <label
                            htmlFor='bedroomWithoutBalcony'
                            className='block text-sm font-medium text-gray-700'>
                            Bedroom without Balcony
                          </label>
                          <select
                            id='bedroomWithoutBalcony'
                            name='bedroomWithoutBalcony'
                            className='mt-0 block w-full py-2 px-3 border  bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                            <option value=''>Select</option>
                            <option value='0'>0</option>
                            <option value='1'>1</option>
                            <option value='2'>2</option>
                            <option value='3'>3</option>
                            <option value='4'>4</option>
                          </select>
                        </div>
                        <div className='col-span-6 sm:col-span-3'>
                          <label
                            htmlFor='kitchen'
                            className='block text-sm font-medium text-gray-700'>
                            Kitchen
                          </label>
                          <select
                            id='kitchen'
                            name='kitchen'
                            className='mt-0 block w-full py-2 px-3 border  bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                            <option value=''>Select</option>
                            <option value='0'>0</option>
                            <option value='1'>1</option>
                            <option value='2'>2</option>
                            <option value='3'>3</option>
                            <option value='4'>4</option>
                          </select>
                        </div>
                        <div className='col-span-6 sm:col-span-3'>
                          <label
                            htmlFor='hallWithoutBalcony'
                            className='block text-sm font-medium text-gray-700'>
                            Hall without Balcony
                          </label>
                          <select
                            id='hallWithoutBalcony'
                            name='hallWithoutBalcony'
                            className='mt-0 block w-full py-2 px-3 border  bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                            <option value=''>Select</option>
                            <option value='0'>0</option>
                            <option value='1'>1</option>
                            <option value='2'>2</option>
                            <option value='3'>3</option>
                            <option value='4'>4</option>
                          </select>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            In a Gated Society
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={gatedSociety}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setgatedSociety(!gatedSociety);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-4 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Corner Property
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={cornerProperty}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setcornerProperty(!cornerProperty);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-3 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Pet Friendly
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={petFriendly}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setpetFriendly(!petFriendly);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-5 sm:col-span-3'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            WheelChair Friendly
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={wheelchairFriendly}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setWheelChairFriendly(!wheelchairFriendly);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-3 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Study Room
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={studyRoom}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setstudyRoom(!studyRoom);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-3 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Store Room
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={storeRoom}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setstoreRoom(!storeRoom);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-3 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Pooja Room
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={poojaRoom}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setpoojaRoom(!poojaRoom);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-3 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Servant Room
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={servantRoom}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setservantRoom(!servantRoom);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='boundaryWall'
                            className='block text-sm font-medium text-gray-700'>
                            Is Boundary Wall Made ?
                          </label>
                          <select
                            id='boundaryWall'
                            name='boundaryWall'
                            className='mt-0 block w-full py-2 px-3 border  bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                            <option value=''>Select</option>
                            <option value='Yes'>Yes</option>
                            <option value='No'>No</option>
                          </select>
                        </div>
                        <div className='col-span-3 sm:col-span-2'>
                          <label
                            htmlFor='bathrooms'
                            className='block text-sm font-medium text-gray-700'>
                            Bathrooms
                          </label>
                          <select
                            id='bathrooms'
                            name='bathrooms'
                            className='mt-0 block w-full py-2 px-3 border  bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                            <option value=''>Select</option>
                            <option value='0'>0</option>
                            <option value='1'>1</option>
                            <option value='2'>2</option>
                            <option value='3'>3</option>
                            <option value='4'>4</option>
                          </select>
                        </div>
                        <div className='col-span-3 sm:col-span-2'>
                          <label
                            htmlFor='balconies'
                            className='block text-sm font-medium text-gray-700'>
                            Balconies
                          </label>
                          <select
                            id='balconies'
                            name='balconies'
                            className='mt-0 block w-full py-2 px-3 border  bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                            <option value=''>Select</option>
                            <option value='0'>0</option>
                            <option value='1'>1</option>
                            <option value='2'>2</option>
                            <option value='3'>3</option>
                            <option value='4'>4</option>
                          </select>
                        </div>
                        <div className='col-span-6 sm:col-span-3'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Outdoor Sports Available
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={outdoorSportsEnabled}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setoutdoorSportsEnabled(
                                    !outdoorSportsEnabled,
                                  );
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div
                          className={`col-span-6 sm:col-span-2 ${
                            outdoorSportsEnabled ? "opacity-100" : "opacity-20"
                          } duration-300`}>
                          <label
                            htmlFor='outdoorSports'
                            className='block text-sm font-medium text-gray-700'>
                            OutDoor Sports
                          </label>
                          <input
                            type='text'
                            name='outdoorSports'
                            id='outdoorSports'
                            maxLength='100'
                            className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                          />
                        </div>
                        <div className='col-span-6 sm:col-span-3'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Indoor Sports Available
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={indoorSportsEnabled}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setindoorSportsEnabled(!indoorSportsEnabled);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div
                          className={`col-span-6 sm:col-span-2 ${
                            indoorSportsEnabled ? "opacity-100" : "opacity-20"
                          } duration-300`}>
                          <label
                            htmlFor='indoorSports'
                            className='block text-sm font-medium text-gray-700'>
                            InDoor Sports
                          </label>
                          <input
                            type='text'
                            name='indoorSports'
                            id='indoorSports'
                            maxLength='100'
                            className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                          />
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Fittings
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={fittingsEnabled}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setfittingsEnabled(!fittingsEnabled);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div
                          className={`col-span-6 sm:col-span-2 ${
                            fittingsEnabled ? "opacity-100" : "opacity-20"
                          } duration-300`}>
                          <label
                            htmlFor='fittingsComment'
                            className='block text-sm font-medium text-gray-700'>
                            Fittings Comment
                          </label>
                          <input
                            type='text'
                            name='fittingsComment'
                            id='fittingsComment'
                            maxLength='100'
                            className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                          />
                        </div>
                        <div className='col-span-12 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Walls Paint
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={wallsPaintEnabled}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setwallsPaintEnabled(!wallsPaintEnabled);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-8 sm:col-span-3'>
                          <label
                            htmlFor='flooring'
                            className='block text-sm font-medium text-gray-700'>
                            Flooring
                          </label>
                          <select
                            id='flooring'
                            name='flooring'
                            className='mt-0 block w-full py-2 px-3 border  bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                            <option value=''>Select</option>
                            <option value='None'>None</option>
                            <option value='Marble'>Marble</option>
                            <option value='Mosaic'>Mosaic</option>
                            <option value='Virtified/Semi-Virtified Tiles'>
                              Virtified/Semi-Virtified Tiles
                            </option>
                            <option value='Cement'>Cement</option>
                            <option value='Wood'>Wood</option>
                            <option value='Granite'>Granite</option>
                            <option value='Spartex'>Spartex</option>
                            <option value='Stone'>Stone</option>
                            <option value='Vinyl'>Vinyl</option>
                            <option value='IPF Finish'>IPF Finish</option>
                            <option value='Others'>Others</option>
                          </select>
                        </div>
                        {propertySubType
                          .toLowerCase()
                          .includes([
                            "guest house / banquet-halls",
                            "business and hotel",
                            "",
                          ]) && (
                          <div className='col-span-4 sm:col-span-2'>
                            <label
                              htmlFor='noofrooms'
                              className='block text-sm font-medium text-gray-700'>
                              No. of Rooms
                            </label>
                            <input
                              type='text'
                              name='noofrooms'
                              id='noofrooms'
                              maxLength='100'
                              className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                            />
                          </div>
                        )}
                        {propertySubType
                          .toLowerCase()
                          .includes([
                            "guest house / banquet-halls",
                            "business and hotel",
                            "",
                          ]) && (
                          <div className='col-span-6 sm:col-span-2'>
                            <label
                              htmlFor='qualityRatings'
                              className='block text-sm font-medium text-gray-700'>
                              Quality Ratings
                            </label>
                            <select
                              id='qualityRatings'
                              name='qualityRatings'
                              className='mt-0 block w-full py-2 px-3 border  bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                              <option value=''>Select</option>
                              <option value='1'>1</option>
                              <option value='2'>2</option>
                              <option value='3'>3</option>
                              <option value='4'>4</option>
                              <option value='5'>5</option>
                            </select>
                          </div>
                        )}
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='furnishing'
                            className='block text-sm font-medium text-gray-700'>
                            Furnishing
                          </label>
                          <select
                            id='furnishing'
                            name='furnishing'
                            defaultValue={furnishedStatus}
                            onChange={(e) => {
                              setFurnishedStatus(e.target.value);
                            }}
                            className='mt-0 block w-full py-2 px-3 border  bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                            <option value=''>Select</option>
                            <option value='Furnished'>Furnished</option>
                            <option value='Semi-Furnished'>
                              Semi-Furnished
                            </option>
                            <option value='Unfurnished'>Unfurnished</option>
                          </select>
                        </div>
                      </div>
                      {(furnishedStatus.toLowerCase() === "furnished" ||
                        furnishedStatus.toLowerCase() === "semi-furnished") && (
                        <div className='mt-3 grid grid-cols-12 gap-2 bg-yellow-50 rounded-sm p-4'>
                          <div className='col-span-12 flex-1 min-w-0 px-0 lg:px-0'>
                            <h2 className='text-lg font-semibold leading-3 text-gray-dark '>
                              Furnishing
                            </h2>
                          </div>
                          <div className='col-span-3 sm:col-span-1'>
                            <label
                              htmlFor='wardrobe'
                              className='block text-sm font-medium text-gray-700'>
                              Wardrobe
                            </label>
                            <input
                              type='tel'
                              name='wardrobe'
                              id='wardrobe'
                              maxLength='2'
                              className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm rounded-sm'
                            />
                          </div>
                          <div className='col-span-3 sm:col-span-1'>
                            <label
                              htmlFor='beds'
                              className='block text-sm font-medium text-gray-700'>
                              Beds
                            </label>
                            <input
                              type='tel'
                              name='beds'
                              id='beds'
                              maxLength='2'
                              className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm rounded-sm'
                            />
                          </div>
                          <div className='col-span-3 sm:col-span-1'>
                            <label
                              htmlFor='geyser'
                              className='block text-sm font-medium text-gray-700'>
                              Geyser
                            </label>
                            <input
                              type='tel'
                              name='geyser'
                              id='geyser'
                              maxLength='2'
                              className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm rounded-sm'
                            />
                          </div>
                          <div className='col-span-3 sm:col-span-1'>
                            <label
                              htmlFor='fans'
                              className='block text-sm font-medium text-gray-700'>
                              Fans
                            </label>
                            <input
                              type='tel'
                              name='fans'
                              id='fans'
                              maxLength='2'
                              className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm rounded-sm'
                            />
                          </div>
                          <div className='col-span-3 sm:col-span-1'>
                            <label
                              htmlFor='light'
                              className='block text-sm font-medium text-gray-700'>
                              Light
                            </label>
                            <input
                              type='tel'
                              name='light'
                              id='light'
                              maxLength='2'
                              className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm rounded-sm'
                            />
                          </div>
                          <div className='col-span-3 sm:col-span-1'>
                            <label
                              htmlFor='aircondition'
                              className='block text-sm font-medium text-gray-700'>
                              AC
                            </label>
                            <input
                              type='tel'
                              name='aircondition'
                              id='aircondition'
                              maxLength='2'
                              className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm rounded-sm'
                            />
                          </div>
                          <div className='col-span-3 sm:col-span-1'>
                            <label
                              htmlFor='television'
                              className='block text-sm font-medium text-gray-700'>
                              TV
                            </label>
                            <input
                              type='tel'
                              name='television'
                              id='television'
                              maxLength='2'
                              className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm rounded-sm'
                            />
                          </div>
                          <div className='col-span-3 sm:col-span-1'>
                            <label
                              htmlFor=''
                              className='block text-sm font-medium text-gray-700'>
                              Stove
                            </label>
                            <div className='flex mt-2'>
                              <label className='ml-7 relative items-center cursor-pointer'>
                                <input
                                  type='checkbox'
                                  className='sr-only peer '
                                  checked={stove}
                                  readOnly
                                />
                                <div
                                  onClick={() => {
                                    setstove(!stove);
                                  }}
                                  className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                              </label>
                            </div>
                          </div>
                          <div className='col-span-3 sm:col-span-1'>
                            <label
                              htmlFor=''
                              className='block text-sm font-medium text-gray-700'>
                              Microwave
                            </label>
                            <div className='flex mt-2'>
                              <label className='ml-7 relative items-center cursor-pointer'>
                                <input
                                  type='checkbox'
                                  className='sr-only peer '
                                  checked={microwave}
                                  readOnly
                                />
                                <div
                                  onClick={() => {
                                    setmicrowave(!microwave);
                                  }}
                                  className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                              </label>
                            </div>
                          </div>
                          <div className='col-span-4 sm:col-span-1'>
                            <label
                              htmlFor=''
                              className='block text-sm font-medium text-gray-700'>
                              Dining Table
                            </label>
                            <div className='flex mt-2'>
                              <label className='ml-7 relative items-center cursor-pointer'>
                                <input
                                  type='checkbox'
                                  className='sr-only peer '
                                  checked={diningTable}
                                  readOnly
                                />
                                <div
                                  onClick={() => {
                                    setdiningTable(!diningTable);
                                  }}
                                  className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                              </label>
                            </div>
                          </div>
                          <div className='col-span-4 sm:col-span-1'>
                            <label
                              htmlFor=''
                              className='block text-sm font-medium text-gray-700'>
                              Modular Kitchen
                            </label>
                            <div className='flex mt-2'>
                              <label className='ml-7 relative items-center cursor-pointer'>
                                <input
                                  type='checkbox'
                                  className='sr-only peer '
                                  checked={modularkitchen}
                                  readOnly
                                />
                                <div
                                  onClick={() => {
                                    setmodularkitchen(!modularkitchen);
                                  }}
                                  className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                              </label>
                            </div>
                          </div>
                          <div className='col-span-4 sm:col-span-1'>
                            <label
                              htmlFor=''
                              className='block text-sm font-medium text-gray-700'>
                              Washing Machine
                            </label>
                            <div className='flex mt-2'>
                              <label className='ml-7 relative items-center cursor-pointer'>
                                <input
                                  type='checkbox'
                                  className='sr-only peer '
                                  checked={washingMachine}
                                  readOnly
                                />
                                <div
                                  onClick={() => {
                                    setwashingMachine(!washingMachine);
                                  }}
                                  className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                              </label>
                            </div>
                          </div>
                          <div className='col-span-3 sm:col-span-1'>
                            <label
                              htmlFor=''
                              className='block text-sm font-medium text-gray-700'>
                              Curtains
                            </label>
                            <div className='flex mt-2'>
                              <label className='ml-7 relative items-center cursor-pointer'>
                                <input
                                  type='checkbox'
                                  className='sr-only peer '
                                  checked={curtains}
                                  readOnly
                                />
                                <div
                                  onClick={() => {
                                    setcurtains(!curtains);
                                  }}
                                  className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                              </label>
                            </div>
                          </div>
                          <div className='col-span-3 sm:col-span-1'>
                            <label
                              htmlFor=''
                              className='block text-sm font-medium text-gray-700'>
                              Fridge
                            </label>
                            <div className='flex mt-2'>
                              <label className='ml-7 relative items-center cursor-pointer'>
                                <input
                                  type='checkbox'
                                  className='sr-only peer '
                                  checked={fridge}
                                  readOnly
                                />
                                <div
                                  onClick={() => {
                                    setfridge(!fridge);
                                  }}
                                  className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                              </label>
                            </div>
                          </div>
                          <div className='col-span-3 sm:col-span-1'>
                            <label
                              htmlFor=''
                              className='block text-sm font-medium text-gray-700'>
                              Water Purifier
                            </label>
                            <div className='flex mt-2'>
                              <label className='ml-7 relative items-center cursor-pointer'>
                                <input
                                  type='checkbox'
                                  className='sr-only peer '
                                  checked={waterPurifier}
                                  readOnly
                                />
                                <div
                                  onClick={() => {
                                    setwaterPurifier(!waterPurifier);
                                  }}
                                  className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                              </label>
                            </div>
                          </div>
                          <div className='col-span-3 sm:col-span-1'>
                            <label
                              htmlFor=''
                              className='block text-sm font-medium text-gray-700'>
                              Chimney
                            </label>
                            <div className='flex mt-2'>
                              <label className='ml-7 relative items-center cursor-pointer'>
                                <input
                                  type='checkbox'
                                  className='sr-only peer '
                                  checked={chimney}
                                  readOnly
                                />
                                <div
                                  onClick={() => {
                                    setchimney(!chimney);
                                  }}
                                  className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                              </label>
                            </div>
                          </div>
                          <div className='col-span-3 sm:col-span-1'>
                            <label
                              htmlFor=''
                              className='block text-sm font-medium text-gray-700'>
                              Sofa
                            </label>
                            <div className='flex mt-2'>
                              <label className='ml-7 relative items-center cursor-pointer'>
                                <input
                                  type='checkbox'
                                  className='sr-only peer '
                                  checked={sofaenabled}
                                  readOnly
                                />
                                <div
                                  onClick={() => {
                                    setsofaenabled(!sofaenabled);
                                  }}
                                  className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                              </label>
                            </div>
                          </div>
                          <div className='col-span-3 sm:col-span-1'>
                            <label
                              htmlFor=''
                              className='block text-sm font-medium text-gray-700'>
                              Exhaust Fan
                            </label>
                            <div className='flex mt-2'>
                              <label className='ml-7 relative items-center cursor-pointer'>
                                <input
                                  type='checkbox'
                                  className='sr-only peer '
                                  checked={exhaustFan}
                                  readOnly
                                />
                                <div
                                  onClick={() => {
                                    setexhaustFan(!exhaustFan);
                                  }}
                                  className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                              </label>
                            </div>
                          </div>
                          <div className='col-span-12 sm:col-span-4'>
                            <label
                              htmlFor='otherFurnishing'
                              className='block text-sm font-medium text-gray-700'>
                              Other Furnishing
                            </label>
                            <input
                              type='text'
                              name='otherFurnishing'
                              id='otherFurnishing'
                              maxLength='50'
                              className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm rounded-sm'
                            />
                          </div>
                        </div>
                      )}
                      <div
                        className={`mt-3 grid grid-cols-12 gap-2 ${
                          furnishedStatus.toLowerCase() === "furnished" ||
                          furnishedStatus.toLowerCase() === "semi-furnished"
                            ? "bg-gray-100"
                            : "bg-yellow-50"
                        } rounded-sm p-4`}>
                        <div className='col-span-12 flex-1 min-w-0 px-0 lg:px-0'>
                          <h2 className='text-lg font-semibold leading-3 text-gray-dark '>
                            Other Amenities
                          </h2>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Visitor Parking
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={visitorParking}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setvisitorParking(!visitorParking);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Security/Fire Alarm
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={fireAlarm}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setfireAlarm(!fireAlarm);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Security Personnel
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={securityPersonnel}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setsecurityPersonnel(!securityPersonnel);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Maintanence Staff
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={maintanenceStaff}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setmaintanenceStaff(!maintanenceStaff);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Water Storage
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={waterStorage}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setwaterStorage(!waterStorage);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Centralised AC
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={centralAC}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setcentralAC(!centralAC);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Fleng Shui/Vaasthu Compliant
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={vaasthuCompliant}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setvaasthuCompliant(!vaasthuCompliant);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Water Disposal
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={waterDisposal}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setwaterDisposal(!waterDisposal);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Fitness Centre / Gym
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={gym}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setgym(!gym);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Rain Water Harvesting
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={rainWaterHarvesting}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setrainWaterHarvesting(!rainWaterHarvesting);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Swimming Pool
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={swimmingPool}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setswimmingPool(!swimmingPool);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Lifts
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={lifts}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setlifts(!lifts);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Club House / Community Centre
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={clubHouse}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setclubHouse(!clubHouse);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Intercom Facility
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={intercomFacility}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setintercomFacility(!intercomFacility);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Service / Goods Lift
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={serviceLift}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setserviceLift(!serviceLift);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            ATM
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={atmenabled}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setatmenabled(!atmenabled);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Access to High Speed Internet / Wifi
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={highSpeedInternet}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  sethighSpeedInternet(!highSpeedInternet);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Cafeteria Food Court
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={cafeteria}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setcafeteria(!cafeteria);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Park
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={parkenabled}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setparkenabled(!parkenabled);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Water Purifier
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={waterPurifier2}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setwaterPurifier2(!waterPurifier2);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Bar / Lounge
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={barenabled}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setbarenabled(!barenabled);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Conference Room
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={conferenceRoom}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setconferenceRoom(!conferenceRoom);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Piped Gas
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={pipedGas}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setpipedGas(!pipedGas);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Private Garden / Terrace
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={privateGarden}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setprivateGarden(!privateGarden);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Shopping Centre
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={shoppingCentre}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setshoppingCentre(!shoppingCentre);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Parking Available
                          </label>
                          <div className='flex mt-2'>
                            <label className='ml-7 relative items-center cursor-pointer'>
                              <input
                                type='checkbox'
                                className='sr-only peer '
                                checked={parkingAvailable}
                                readOnly
                              />
                              <div
                                onClick={() => {
                                  setparkingAvailable(!parkingAvailable);
                                }}
                                className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                            </label>
                          </div>
                        </div>

                        <div
                          className={`col-span-6 sm:col-span-3 ${
                            parkingAvailable ? "opacity-100" : "opacity-20"
                          } duration-300`}>
                          <label
                            htmlFor='openParkingCnt'
                            className='block text-sm font-medium text-gray-700'>
                            Open Parking (Number)
                          </label>
                          <input
                            type='tel'
                            name='openParkingCnt'
                            id='openParkingCnt'
                            maxLength='2'
                            className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                          />
                        </div>
                        <div
                          className={`col-span-6 sm:col-span-3 ${
                            parkingAvailable ? "opacity-100" : "opacity-20"
                          } duration-300`}>
                          <label
                            htmlFor='closedParkingCnt'
                            className='block text-sm font-medium text-gray-700'>
                            Closed Parking (Number)
                          </label>
                          <input
                            type='tel'
                            name='closedParkingCnt'
                            id='closedParkingCnt'
                            maxLength='2'
                            className='mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-sm'
                          />
                        </div>
                        <div className='col-span-6 sm:col-span-3'>
                          <label
                            htmlFor='powerBackup'
                            className='block text-sm font-medium text-gray-700'>
                            Power Backup
                          </label>
                          <select
                            id='powerBackup'
                            name='powerBackup'
                            className='mt-0 block w-full py-2 px-3 border  bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                            <option value=''>Select</option>
                            <option value='None'>None</option>
                            <option value='Partial'>Partial</option>
                            <option value='Tank'>Full</option>
                          </select>
                        </div>
                        <div className='col-span-6 sm:col-span-3'>
                          <label
                            htmlFor='waterSource'
                            className='block text-sm font-medium text-gray-700'>
                            Water Source
                          </label>
                          <select
                            id='waterSource'
                            name='waterSource'
                            className='mt-0 block w-full py-2 px-3 border  bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                            <option value=''>Select</option>
                            <option value='Municipal Corporation'>
                              Municipal Corporation
                            </option>
                            <option value='Borewell'>Borewell</option>
                            <option value='Tank'>Tank</option>
                          </select>
                        </div>
                        <div className='col-span-12 sm:col-span-3'>
                          <label
                            htmlFor='overLooking'
                            className='block text-sm font-medium text-gray-700'>
                            Overlooking
                          </label>
                          <select
                            id='overLooking'
                            name='overLooking'
                            className='mt-0 block w-full py-2 px-3 border  bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                            <option value=''>Select</option>
                            <option value='Park / Garden'>Park / Garden</option>
                            <option value='Main Road'>Main Road</option>
                            <option value='Club'>Club</option>
                            <option value='Pool'>Pool</option>
                            <option value='Others'>Others</option>
                          </select>
                        </div>
                      </div>
                      <div className='mt-2 grid grid-cols-12 gap-2 bg-gray-100 rounded-sm p-4'>
                        <div className='col-span-12 min-w-0 px-0 lg:px-0 mb-2'>
                          <h2 className='text-lg font-semibold leading-3 text-gray-dark '>
                            Property Images
                          </h2>
                        </div>
                        <div className='col-span-12 sm:col-span-2 mr-1'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Thumbnail
                          </label>
                          <FileUploader
                            handleChange={uploadThumbnail}
                            name='attachments'
                            multiple={true}
                            label='Upload or Drop files to move enquiry to Service ticket'
                            children={
                              <div className='flex p-2 justify-center border-2 border-yellow-2 cursor-pointer'>
                                <img
                                  src={
                                    thumbnailImage
                                      ? URL.createObjectURL(thumbnailImage)
                                      : "/assets/images/thumbnail_placeholder.jpg"
                                  }
                                  alt='User'
                                  referrerPolicy='no-referrer'
                                  className='w-32 h-32'
                                />
                              </div>
                            }
                            types={["JPG", "PNG"]}
                          />
                        </div>
                        <div className='col-span-12 sm:col-span-10'>
                          <label
                            htmlFor=''
                            className='block text-sm font-medium text-gray-700'>
                            Property Images
                          </label>
                          <div className='grid grid-cols-6 gap-4'>
                            {propertyImageAttachments.length !== 0 ? (
                              propertyImageAttachments.map((item) => (
                                <div
                                  className='col-span-3 sm:col-span-1'
                                  key={item.blobName}>
                                  <PropertyThumbnail
                                    thumbnail={item}
                                    blobContainerName={blobContainerName}
                                  />
                                  <div
                                    className='-mt-2 pt-1 cursor-pointer'
                                    onClick={(e) => {
                                      e.preventDefault();
                                      removePropertyImageAttachments(
                                        item.blobName,
                                      );
                                    }}>
                                    <img
                                      className={`h-5 w-5`}
                                      src='/assets/icons/trash-filled.png'
                                      alt='X'
                                      title='Remove attachment'
                                    />
                                  </div>
                                </div>
                              ))
                            ) : (
                              <></>
                            )}
                            {propertyImageAttachments.length <= 5 && (
                              <div className='col-span-3 sm:col-span-1'>
                                <FileUploader
                                  handleChange={uploadPropertyImage}
                                  name='propertyImage'
                                  multiple={true}
                                  label='Upload or Drop files to move enquiry to Service ticket'
                                  children={
                                    <div className='flex p-2 justify-center border-2 border-yellow-2'>
                                      <img
                                        src='/assets/images/add_property_image.jpg'
                                        alt='Property Image'
                                        referrerPolicy='no-referrer'
                                        className='h-32'
                                      />
                                    </div>
                                  }
                                  types={["JPG", "PNG"]}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='px-4 py-3 bg-gray-50 text-right sm:px-6'>
                      <div className='lg:flex lg:items-center justify-between'>
                        <div
                          className={`flex-1 min-w-0 px-0 lg:px-0 ${
                            requestLoading ? "opacity-70" : "opacity:100"
                          }`}>
                          <Link
                            to='#'
                            onClick={(e) => {
                              e.preventDefault();
                              if (!requestLoading) navigate(-1);
                            }}
                            className='inline-flex justify-center py-2 px-4 border-yellow-2 border shadow-sm text-sm font-medium rounded-sm text-yellow-2 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'>
                            Back
                          </Link>
                          {!requestLoading ? (
                            <button
                              id='submitBtn'
                              type='submit'
                              className='ml-2 inline-flex justify-center py-2 px-4 border-transparent shadow-sm text-sm font-medium rounded-sm text-white bg-yellow-2 hover:bg-gray-dark duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'>
                              Publish to ERP
                            </button>
                          ) : (
                            <button
                              className='animate-bounce ml-2 inline-flex justify-center py-2 px-4 border-transparent shadow-sm text-sm font-medium rounded-sm text-white bg-yellow-2  duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'
                              disabled={true}>
                              Processing...
                            </button>
                          )}
                        </div>
                      </div>
                      <div className='sm: py-2'></div>
                    </div>
                  </div>
                </form>
              </div>
              <div className='block md:hidden'>
                <div className='grid grid-cols-1 gap-4'></div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default PIFCreate;
